import script from "./select-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./select-template.vue?vue&type=script&lang=ts&setup=true"

import "./select-template.vue?vue&type=style&index=0&id=56728246&lang=scss"

const __exports__ = script;

export default __exports__